import axiosInstance from "../../apiAxios/axiosInstance";



// export const getLeadList = async (payload) => {
//   const response = await axiosInstance.post("/admin/lead-filter", payload);
//   return response.data;
// };

export const getLeadList = async (payload) => {
  const response = await axiosInstance.post("/vendor/lead-vendor-status-other", payload);
  return response.data;
};
// For Dashboard
export const getAllLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/get-all-lead-list", payload);
  return response.data;
};

export const getadminPendingLeadList = async (payload) => {
  const response = await axiosInstance.post("/vendor/lead-vendor-status-pending", payload);
  return response.data;
};
export const getNewLeadList = async (payload) => {
  const response = await axiosInstance.post("/vendor/lead-vendor-status-new", payload);
  return response.data;
};
export const getConvertedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-converted", payload);
  return response.data;
};
export const getLostLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-lost", payload);
  return response.data;
};
export const getAssignedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-assigned", payload);
  return response.data;
};
export const getUnAssignedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-unassigned", payload);
  return response.data;
};
//today for admin api
export const getTodayAllLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-all-lead-list", payload);
  return response.data;
};
export const getTodayPendingLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-pending-lead-list", payload);
  return response.data;
};
export const getTodayConvertedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-converted-lead-list", payload);
  return response.data;
};
export const getTodayLostLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-lost-lead-list", payload);
  return response.data;
};
export const getTodayAssignedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-assigned-lead-list", payload);
  return response.data;
};
export const getTodayUnAssignedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-unassigned-lead-list", payload);
  return response.data;
};








// for staff
export const getOtherLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-staff-status-other", payload);
  return response.data;
};

export const getstaffPendingLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-staff-status-pending", payload);
  return response.data;
};
export const AssignedLeadList = async (payload) => {
  const response = await axiosInstance.post("/vendor/lead-staff-status-assigned",payload);
  return response;
};
export const deleteLead = async (payload) => {
  const res = await axiosInstance.post("/vendor/lead-delete", payload);
  return res.data;
};

export const getLeadDetails = async (id) => {
  const response = await axiosInstance.post(
    "/vendor/lead-show",
    { id }
  );

  return response.data;
};
export const updateLead = (paylod) =>
  axiosInstance.post("/vendor/lead-update", paylod)

export const createLead = (payload) =>
  axiosInstance.post("/vendor/lead-store", payload)

const leadCell = (row, names) => {
  const normalized = Object.entries(row || {}).map(([key, value]) => [
    String(key).trim().toLowerCase().replace(/[\s-]+/g, "_"),
    value,
  ]);
  for (const name of names) {
    const found = normalized.find(([key]) => key === name);
    if (found && String(found[1]).trim() !== "") return String(found[1]).trim();
  }
  return "";
};

export const uploadTypedLeadRows = async (rows, leadType) => {
  const payloads = [];
  let skipped = 0;

  (rows || []).forEach((row) => {
    const mobile = leadCell(row, [
      "mobile",
      "mobile_number",
      "phone",
      "phone_number",
      "contact",
      "contact_number",
    ]).replace(/\D/g, "").slice(-10);
    const name = leadCell(row, [
      "name",
      "customer_name",
      "customer",
      "full_name",
      "lead_name",
    ]);

    if (mobile.length !== 10) {
      skipped += 1;
      return;
    }

    payloads.push({
      name: name || "Lead",
      customer_name: name || "Lead",
      mobile,
      email: leadCell(row, ["email", "email_id"]),
      source: leadCell(row, ["source"]) || "Website",
      company_name: leadCell(row, ["company_name", "company"]),
      address: leadCell(row, ["address"]),
      remark: leadCell(row, ["remark", "remarks"]),
      lead_type: leadType,
    });
  });

  let created = 0;
  let failed = 0;
  for (let index = 0; index < payloads.length; index += 5) {
    const chunk = payloads.slice(index, index + 5);
    const results = await Promise.allSettled(chunk.map((payload) => createLead(payload)));
    results.forEach((result) => {
      const body = result.status === "fulfilled" ? result.value?.data : null;
      if (result.status === "fulfilled" && body?.success !== false) created += 1;
      else failed += 1;
    });
  }

  return { created, failed, skipped };
};

export const uploadLeadCSV = (file, leadType) => {
  const formData = new FormData();
  formData.append("csv_file", file);
  if (leadType) formData.append("lead_type", leadType);
  return axiosInstance
    .post("/vendor/lead-vendor-csv-upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(res => res.data);
};

export const uploadLeadExcel = (file, leadType) => {
  const formData = new FormData();
  formData.append("excel_file", file);
  if (leadType) formData.append("lead_type", leadType);
  return axiosInstance
    .post("/vendor/lead-vendor-excel-upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(res => res.data);
};

export const getLeadCSVTemplate = () =>
  axiosInstance
    .get("/vendor/lead-vendor-csv-template", {
      responseType: "blob",
    })
    .then(res => res.data);

export const getLeadExcelTemplate = async () => {
  return axiosInstance.get("/vendor/lead-vendor-excel-template", {
    responseType: "blob",
  });
};

// export const updateLeadStatus = async (payload) => {
//   const response = await axiosInstance.post(
//     "/admin/lead-status-update",
//     payload
//   );

//   return response.data;
// };

export const updateLeadStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/lead-status-update",
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};
export const updateLeadSubStatus = (id, sub_status, remarks) =>
  axiosInstance
    .post("/vendor/lead-substatus-update", {
      id,
      sub_status,
      remarks,
    })
    .then((res) => res.data);